<div class="dialog-container-shrink">
	<h1 matDialogTitle class="dialog-title">{{ title }}</h1>
	<div mat-dialog-content [innerHtml]="content | trustedContent: 'html'"></div>
	<div mat-dialog-actions class="fb-right" style="margin-top: 16px">
		<button mat-button style="margin-left: 8px" (click)="dialogRef.close(true)">
			{{ confirmButtonLabel }}
		</button>
	</div>
</div>
